import {
  Edit,
  SimpleForm,
  TextInput,
  useRecordContext,
} from 'react-admin';
import { Box, Chip } from '@mui/material';

const SkillTitle = () => {
  const record = useRecordContext();
  return (
    <span>
      Document Composer Skill{record ? `: ${record.name ?? record.id}` : ''}
    </span>
  );
};

export const SkillEdit = () => (
  <Edit title={<SkillTitle />} mutationMode="pessimistic" actions={false}>
    <SimpleForm>
      <FunctionField
        label="ID"
        render={(record: any) => (
          <Box sx={{ mb: 2 }}>
            <Chip label={record?.id ?? ''} size="small" />
          </Box>
        )}
      />
      <TextInput source="name" fullWidth />
      <TextInput
        source="explainer"
        label="Explainer (statuses and fields)"
        fullWidth
        multiline
        minRows={10}
        helperText="Human-readable description of expected statuses and what to do with each. Injected when {{ @skill.[skillName].explainer }} is used in a template."
      />
    </SimpleForm>
  </Edit>
);
